export default __webpack_public_path__ + "static/media/user-icon.c95b05e5.svg";